import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09e4e7a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "doc-id" }
const _hoisted_2 = { class: "ion-padding" }
const _hoisted_3 = { class: "overline" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "doc-meta"
}
const _hoisted_6 = { class: "scanner" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["data-product-id"]
const _hoisted_9 = { class: "product-info" }
const _hoisted_10 = { class: "location" }
const _hoisted_11 = {
  key: 0,
  class: "product-count"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  class: "action border-top"
}
const _hoisted_14 = { class: "receive-all-qty" }
const _hoisted_15 = { class: "qty-progress" }
const _hoisted_16 = { class: "to-item-history" }
const _hoisted_17 = { class: "qty-ordered" }
const _hoisted_18 = ["data-product-id"]
const _hoisted_19 = { class: "product-info" }
const _hoisted_20 = { class: "location" }
const _hoisted_21 = { class: "product-count" }
const _hoisted_22 = {
  key: 0,
  class: "action border-top"
}
const _hoisted_23 = { class: "receive-all-qty" }
const _hoisted_24 = { class: "qty-progress" }
const _hoisted_25 = { class: "to-item-history" }
const _hoisted_26 = { class: "qty-ordered" }
const _hoisted_27 = {
  key: 1,
  "data-testid": "transfer-order-detail-page-open-empty-state",
  class: "empty-state"
}
const _hoisted_28 = ["data-product-id"]
const _hoisted_29 = { class: "product-info" }
const _hoisted_30 = { class: "location" }
const _hoisted_31 = {
  key: 0,
  "data-testid": "transfer-order-detail-page-received-empty-state",
  class: "empty-state"
}
const _hoisted_32 = ["data-product-id"]
const _hoisted_33 = { class: "product-info" }
const _hoisted_34 = { class: "location" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_DxpShopifyImg = _resolveComponent("DxpShopifyImg")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_toast = _resolveComponent("ion-toast")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_back_button, {
                "data-testid": "transfer-order-detail-page-back-btn",
                "default-href": "/transfer-orders",
                slot: "start"
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Transfer Order Details")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    "data-testid": "transfer-order-detail-page-history-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.receivingHistory()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.timeOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    "data-testid": "transfer-order-detail-page-add-product-btn",
                    disabled: !_ctx.hasPermission(_ctx.Actions.APP_SHIPMENT_ADMIN) || _ctx.isTOReceived(),
                    onClick: _ctx.addProduct
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.addOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { "data-testid": "transfer-order-detail-page-content" }, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.order.orderId), 1),
                    _createElementVNode("h1", null, _toDisplayString(_ctx.translate("Transfer Order")) + ": " + _toDisplayString(_ctx.order.orderName ? _ctx.order.orderName : _ctx.order.externalId ? _ctx.order.externalId : _ctx.order.orderId), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.translate("Item count")) + ": " + _toDisplayString(_ctx.order.items?.length), 1),
                    (_ctx.isReceivingByFulfillment && !_ctx.isTOReceived())
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.translate("Unfulfilled items")) + ": " + _toDisplayString(_ctx.order.items?.length - _ctx.fulfilledItems), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trackedPackages, (pkg, index) => {
                      return (_openBlock(), _createBlock(_component_ion_chip, {
                        key: index,
                        onClick: ($event: any) => (_ctx.copyToClipboard(pkg.trackingCode, 'Tracking code copied to clipboard'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(pkg.trackingCode) + " ", 1),
                          _createVNode(_component_ion_icon, { icon: _ctx.copyOutline }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              (!_ctx.isTOReceived())
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_ion_item, {
                      "data-testid": "transfer-order-detail-page-instructions-btn",
                      button: "",
                      lines: "none",
                      onClick: _ctx.openTOReceivingInstructions
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.informationCircleOutline,
                          slot: "start"
                        }, null, 8, ["icon"]),
                        _createVNode(_component_ion_label, { slot: "end" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Finish receiving the open items to complete this transfer order", { items: _ctx.getTOItems("open").length })) + " ", 1),
                            _createElementVNode("p", null, [
                              _createVNode(_component_ion_text, { color: "danger" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("This transfer order can only be received on one device at a time. Make sure this transfer order is not open on any other device")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("p", null, _toDisplayString(_ctx.translate("Tap to learn more")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ion_item, {
                lines: _ctx.scanErrorText ? 'none' : 'full'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_input, {
                    "data-testid": "transfer-order-detail-page-scan-input",
                    class: _normalizeClass({ 'ion-invalid ion-touched': _ctx.scanErrorText }),
                    "error-text": _ctx.scanErrorText,
                    label: _ctx.translate('Scan items'),
                    "label-placement": "fixed",
                    autofocus: "",
                    modelValue: _ctx.queryString,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryString) = $event)),
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.updateProductCount(null)), ["enter"])),
                    onIonInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scanErrorText = ''))
                  }, null, 8, ["class", "error-text", "label", "modelValue"])
                ]),
                _: 1
              }, 8, ["lines"]),
              _createVNode(_component_ion_button, {
                "data-testid": "transfer-order-detail-page-scan-btn",
                expand: "block",
                fill: "outline",
                onClick: _ctx.scan
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    icon: _ctx.cameraOutline
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.translate("Scan")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            (!_ctx.isTOReceived())
              ? (_openBlock(), _createBlock(_component_ion_segment, {
                  key: 0,
                  "data-testid": "transfer-order-detail-page-segment",
                  value: _ctx.selectedSegment,
                  onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.segmentChanged($event.detail.value)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_segment_button, {
                      "data-testid": "transfer-order-detail-page-all-tab",
                      value: "all",
                      "content-id": "all"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("All")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, {
                      "data-testid": "transfer-order-detail-page-open-tab",
                      value: "open",
                      "content-id": "open"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getTOItems("open")?.length) + " " + _toDisplayString(_ctx.translate("Open")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, {
                      "data-testid": "transfer-order-detail-page-received-tab",
                      value: "received",
                      "content-id": "received"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getTOItems("received")?.length) + " " + _toDisplayString(_ctx.translate("Received and completed")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]))
              : _createCommentVNode("", true),
            (!_ctx.isTOReceived())
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.selectedSegment === 'all')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.openItemsTemp.length)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 0,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("To close this order, enter the actual quantity received or enter '0' if the item was not received.")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  slot: "end",
                                  onClick: _ctx.showAllOpenItems
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("Back to all items")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllItems, (item, index) => {
                          return (_openBlock(), _createBlock(_component_ion_card, {
                            "data-testid": `transfer-order-detail-page-all-item-card-${item.orderItemSeqId || item.productId}`,
                            key: index
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "product",
                                "data-product-id": item.productId
                              }, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_thumbnail, {
                                        slot: "start",
                                        onClick: ($event: any) => (_ctx.openImage(_ctx.getProduct(item.productId).mainImageUrl, _ctx.getProduct(item.productId).itemDescription))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxpShopifyImg, {
                                            size: "small",
                                            src: _ctx.getProduct(item.productId).mainImageUrl
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h2", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) ? _ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) : _ctx.getProduct(item.productId).productName), 1),
                                          _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, _ctx.getProduct(item.productId))), 1),
                                          _createElementVNode("p", null, _toDisplayString(_ctx.getFeatures(_ctx.getProduct(item.productId).productFeatures)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  (!_ctx.productQoh[item.productId] && _ctx.productQoh[item.productId] !== 0)
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        "data-testid": `transfer-order-detail-page-fetch-qoh-btn-${item.orderItemSeqId || item.productId}`,
                                        fill: "clear",
                                        onClick: _withModifiers(($event: any) => (_ctx.fetchQuantityOnHand(item.productId)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            color: "medium",
                                            slot: "icon-only",
                                            icon: _ctx.cubeOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["data-testid", "onClick"]))
                                    : (_openBlock(), _createBlock(_component_ion_chip, {
                                        key: 1,
                                        outline: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.translate("on hand", { qoh: _ctx.productQoh[item.productId] })) + " ", 1),
                                          _createVNode(_component_ion_icon, {
                                            color: "medium",
                                            icon: _ctx.cubeOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                ]),
                                (!['ITEM_COMPLETED', 'ITEM_REJECTED', 'ITEM_CANCELLED'].includes(item.statusId))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      _createVNode(_component_ion_input, {
                                        "data-testid": `transfer-order-detail-page-qty-input-${item.orderItemSeqId || item.productId}`,
                                        fill: "outline",
                                        class: _normalizeClass({ 'ion-invalid ion-touched': _ctx.openItemsTemp.length }),
                                        label: _ctx.translate('Qty'),
                                        "label-placement": "floating",
                                        type: "number",
                                        min: "0",
                                        modelValue: item.quantityAccepted,
                                        "onUpdate:modelValue": ($event: any) => ((item.quantityAccepted) = $event),
                                        disabled: _ctx.isForceScanEnabled,
                                        "error-text": _ctx.openItemsTemp.length ? _ctx.translate('Input quantity') : ''
                                      }, null, 8, ["data-testid", "class", "label", "modelValue", "onUpdate:modelValue", "disabled", "error-text"])
                                    ]))
                                  : (!item.orderItemSeqId)
                                    ? (_openBlock(), _createBlock(_component_ion_item, {
                                        key: 1,
                                        lines: "none"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { slot: "end" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.translate(' Received', { received: item.quantityAccepted ?? 0 })) + " ", 1),
                                              _createElementVNode("p", null, _toDisplayString(_ctx.translate('Manually added')), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createVNode(_component_ion_item, { lines: "none" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, { slot: "end" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.translate(' Received | Fulfilled | Ordered',{ received: item.totalReceivedQuantity ?? 0, fulfilled:item.totalIssuedQuantity ?? 0 , ordered: item.quantity })), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                              ], 8, _hoisted_8),
                              (!['ITEM_COMPLETED', 'ITEM_REJECTED', 'ITEM_CANCELLED'].includes(item.statusId))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (item.orderItemSeqId)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                          _createElementVNode("div", _hoisted_14, [
                                            _createVNode(_component_ion_button, {
                                              "data-testid": `transfer-order-detail-page-receive-all-btn-${item.orderItemSeqId || item.productId}`,
                                              onClick: ($event: any) => (_ctx.receiveAll(item)),
                                              disabled: _ctx.isForceScanEnabled || _ctx.isItemReceivedInFull(item),
                                              slot: "start",
                                              size: "small",
                                              fill: "outline"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.translate("Receive All")), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["data-testid", "onClick", "disabled"])
                                          ]),
                                          _createElementVNode("div", _hoisted_15, [
                                            _createVNode(_component_ion_progress_bar, {
                                              color: _ctx.getRcvdToOrderedFraction(item) === 1 ? 'success' : _ctx.getRcvdToOrderedFraction(item) > 1 ? 'danger' : 'primary',
                                              value: _ctx.getRcvdToOrderedFraction(item)
                                            }, null, 8, ["color", "value"])
                                          ]),
                                          _createElementVNode("div", _hoisted_16, [
                                            _createVNode(_component_ion_chip, {
                                              "data-testid": `transfer-order-detail-page-item-history-chip-${item.orderItemSeqId || item.productId}`,
                                              outline: "",
                                              onClick: ($event: any) => (_ctx.receivingHistory(item.productId, item.orderItemSeqId))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, { icon: _ctx.checkmarkDone }, null, 8, ["icon"]),
                                                _createVNode(_component_ion_label, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.totalReceivedQuantity ?? 0) + " " + _toDisplayString(_ctx.translate("received")), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["data-testid", "onClick"])
                                          ]),
                                          _createElementVNode("div", _hoisted_17, [
                                            (_ctx.isReceivingByFulfillment)
                                              ? (_openBlock(), _createBlock(_component_ion_label, { key: 0 }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.totalIssuedQuantity || 0) + " " + _toDisplayString(_ctx.translate("fulfilled")), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : (_openBlock(), _createBlock(_component_ion_label, { key: 1 }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.quantity) + " " + _toDisplayString(_ctx.translate("ordered")), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["data-testid"]))
                        }), 128)),
                        (_ctx.openItemsTemp.length)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 1,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.openItemsTemp.length) + " " + _toDisplayString(_ctx.translate("more items are ready to be received")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.selectedSegment === 'open')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_ctx.openItemsTemp.length)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 0,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "danger" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("To close this order, enter the actual quantity received or enter '0' if the item was not received.")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_button, {
                                  fill: "clear",
                                  slot: "end",
                                  onClick: _ctx.showAllOpenItems
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.translate("Back to open items")), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openItems, (item, index) => {
                          return (_openBlock(), _createBlock(_component_ion_card, {
                            "data-testid": `transfer-order-detail-page-open-item-card-${item.orderItemSeqId || item.productId}`,
                            key: index,
                            class: _normalizeClass(_ctx.getProductIdentificationValue(_ctx.barcodeIdentifier, _ctx.getProduct(item.productId)) === _ctx.lastScannedId ? 'scanned-item' : '' ),
                            id: _ctx.getProductIdentificationValue(_ctx.barcodeIdentifier, _ctx.getProduct(item.productId))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "product",
                                "data-product-id": item.productId
                              }, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_thumbnail, {
                                        slot: "start",
                                        onClick: ($event: any) => (_ctx.openImage(_ctx.getProduct(item.productId).mainImageUrl, _ctx.getProduct(item.productId).itemDescription))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxpShopifyImg, {
                                            size: "small",
                                            src: _ctx.getProduct(item.productId).mainImageUrl
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h2", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) ? _ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) : _ctx.getProduct(item.productId).productName), 1),
                                          _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, _ctx.getProduct(item.productId))), 1),
                                          _createElementVNode("p", null, _toDisplayString(_ctx.getFeatures(_ctx.getProduct(item.productId).productFeatures)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  (!_ctx.productQoh[item.productId] && _ctx.productQoh[item.productId] !== 0)
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        "data-testid": `transfer-order-detail-page-open-fetch-qoh-btn-${item.orderItemSeqId || item.productId}`,
                                        color: "medium",
                                        fill: "clear",
                                        onClick: _withModifiers(($event: any) => (_ctx.fetchQuantityOnHand(item.productId)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            slot: "icon-only",
                                            icon: _ctx.cubeOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["data-testid", "onClick"]))
                                    : (_openBlock(), _createBlock(_component_ion_chip, {
                                        key: 1,
                                        outline: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.translate("on hand", { qoh: _ctx.productQoh[item.productId] })) + " ", 1),
                                          _createVNode(_component_ion_icon, {
                                            color: "medium",
                                            icon: _ctx.cubeOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_ion_input, {
                                    "data-testid": `transfer-order-detail-page-open-qty-input-${item.orderItemSeqId || item.productId}`,
                                    fill: "outline",
                                    class: _normalizeClass({ 'ion-invalid ion-touched': _ctx.openItemsTemp.length }),
                                    label: _ctx.translate('Qty'),
                                    "label-placement": "floating",
                                    type: "number",
                                    min: "0",
                                    modelValue: item.quantityAccepted,
                                    "onUpdate:modelValue": ($event: any) => ((item.quantityAccepted) = $event),
                                    disabled: _ctx.isForceScanEnabled,
                                    "error-text": _ctx.openItemsTemp.length ? _ctx.translate('Input quantity') : ''
                                  }, null, 8, ["data-testid", "class", "label", "modelValue", "onUpdate:modelValue", "disabled", "error-text"])
                                ])
                              ], 8, _hoisted_18),
                              (item.orderItemSeqId)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(_component_ion_button, {
                                        "data-testid": `transfer-order-detail-page-open-receive-all-btn-${item.orderItemSeqId || item.productId}`,
                                        onClick: ($event: any) => (_ctx.receiveAll(item)),
                                        disabled: _ctx.isForceScanEnabled || _ctx.isItemReceivedInFull(item),
                                        size: "small",
                                        fill: "outline"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.translate("Receive All")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["data-testid", "onClick", "disabled"])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                      _createVNode(_component_ion_progress_bar, {
                                        color: _ctx.getRcvdToOrderedFraction(item) === 1 ? 'success' : _ctx.getRcvdToOrderedFraction(item) > 1 ? 'danger' : 'primary',
                                        value: _ctx.getRcvdToOrderedFraction(item)
                                      }, null, 8, ["color", "value"])
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                      _createVNode(_component_ion_chip, {
                                        "data-testid": `transfer-order-detail-page-open-history-chip-${item.orderItemSeqId || item.productId}`,
                                        outline: "",
                                        onClick: ($event: any) => (_ctx.receivingHistory(item.productId, item.orderItemSeqId))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, { icon: _ctx.checkmarkDone }, null, 8, ["icon"]),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.totalReceivedQuantity ?? 0) + " " + _toDisplayString(_ctx.translate("received")), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["data-testid", "onClick"])
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                      (_ctx.isReceivingByFulfillment)
                                        ? (_openBlock(), _createBlock(_component_ion_label, { key: 0 }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.totalIssuedQuantity || 0) + " " + _toDisplayString(_ctx.translate("fulfilled")), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_openBlock(), _createBlock(_component_ion_label, { key: 1 }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.quantity) + " " + _toDisplayString(_ctx.translate("ordered")), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["data-testid", "class", "id"]))
                        }), 128)),
                        (!_ctx.openItems?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString("No items available for receiving, check completed tab"))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                "data-testid": "transfer-order-detail-page-open-empty-received-btn",
                                fill: "clear",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.segmentChanged('received')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: _ctx.openOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.openItemsTemp.length)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 2,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.openItemsTemp.length) + " " + _toDisplayString(_ctx.translate("more items are ready to be received")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.selectedSegment === 'received')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.completedItems, (item, index) => {
                          return (_openBlock(), _createBlock(_component_ion_card, {
                            "data-testid": `transfer-order-detail-page-received-item-card-${item.orderItemSeqId || item.productId}`,
                            key: index,
                            class: _normalizeClass(_ctx.getProductIdentificationValue(_ctx.barcodeIdentifier, _ctx.getProduct(item.productId)) === _ctx.lastScannedId ? 'scanned-item' : '' ),
                            id: _ctx.getProductIdentificationValue(_ctx.barcodeIdentifier, _ctx.getProduct(item.productId))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "product",
                                "data-product-id": item.productId
                              }, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_thumbnail, {
                                        slot: "start",
                                        onClick: ($event: any) => (_ctx.openImage(_ctx.getProduct(item.productId).mainImageUrl, _ctx.getProduct(item.productId).productName))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxpShopifyImg, {
                                            size: "small",
                                            src: _ctx.getProduct(item.productId).mainImageUrl
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h2", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) ? _ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) : _ctx.getProduct(item.productId).productName), 1),
                                          _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, _ctx.getProduct(item.productId))), 1),
                                          _createElementVNode("p", null, _toDisplayString(_ctx.getFeatures(_ctx.getProduct(item.productId).productFeatures)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  (!_ctx.productQoh[item.productId] && _ctx.productQoh[item.productId] !== 0)
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        "data-testid": `transfer-order-detail-page-received-fetch-qoh-btn-${item.orderItemSeqId || item.productId}`,
                                        fill: "clear",
                                        onClick: _withModifiers(($event: any) => (_ctx.fetchQuantityOnHand(item.productId)), ["stop"])
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_icon, {
                                            color: "medium",
                                            slot: "icon-only",
                                            icon: _ctx.cubeOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["data-testid", "onClick"]))
                                    : (_openBlock(), _createBlock(_component_ion_chip, {
                                        key: 1,
                                        outline: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.translate("on hand", { qoh: _ctx.productQoh[item.productId] })) + " ", 1),
                                          _createVNode(_component_ion_icon, {
                                            color: "medium",
                                            icon: _ctx.cubeOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { slot: "end" }, {
                                        default: _withCtx(() => [
                                          (!item.orderItemSeqId)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(_ctx.translate(' Received', { received: item.quantityAccepted ?? 0 })) + " ", 1),
                                                _createElementVNode("p", null, _toDisplayString(_ctx.translate('Manually added')), 1)
                                              ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(_toDisplayString(_ctx.translate(' Received | Fulfilled | Ordered',{ received: item.totalReceivedQuantity ?? 0, fulfilled:item.totalIssuedQuantity ?? 0 , ordered: item.quantity })), 1)
                                              ], 64))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ], 8, _hoisted_28)
                            ]),
                            _: 2
                          }, 1032, ["data-testid", "class", "id"]))
                        }), 128)),
                        (!_ctx.completedItems?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString("No items are marked as completed, check Open tab"))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                "data-testid": "transfer-order-detail-page-received-empty-open-btn",
                                fill: "clear",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.segmentChanged('open')))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: _ctx.openOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isTOReceived())
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.completedItems, (item, index) => {
                  return (_openBlock(), _createBlock(_component_ion_card, {
                    "data-testid": `transfer-order-detail-page-completed-item-card-${item.orderItemSeqId || item.productId}`,
                    key: index,
                    class: _normalizeClass(_ctx.getProductIdentificationValue(_ctx.barcodeIdentifier, _ctx.getProduct(item.productId)) === _ctx.lastScannedId ? 'scanned-item' : '' ),
                    id: _ctx.getProductIdentificationValue(_ctx.barcodeIdentifier, _ctx.getProduct(item.productId))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "product",
                        "data-product-id": item.productId
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(_component_ion_item, { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_thumbnail, {
                                slot: "start",
                                onClick: ($event: any) => (_ctx.openImage(_ctx.getProduct(item.productId).mainImageUrl, _ctx.getProduct(item.productId).productName))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxpShopifyImg, {
                                    size: "small",
                                    src: _ctx.getProduct(item.productId).mainImageUrl
                                  }, null, 8, ["src"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h2", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) ? _ctx.getProductIdentificationValue(_ctx.productIdentificationPref.primaryId, _ctx.getProduct(item.productId)) : _ctx.getProduct(item.productId).productName), 1),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.getProductIdentificationValue(_ctx.productIdentificationPref.secondaryId, _ctx.getProduct(item.productId))), 1),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.getFeatures(_ctx.getProduct(item.productId).productFeatures)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          (!_ctx.productQoh[item.productId] && _ctx.productQoh[item.productId] !== 0)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 0,
                                "data-testid": `transfer-order-detail-page-completed-fetch-qoh-btn-${item.orderItemSeqId || item.productId}`,
                                fill: "clear",
                                onClick: _withModifiers(($event: any) => (_ctx.fetchQuantityOnHand(item.productId)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    color: "medium",
                                    slot: "icon-only",
                                    icon: _ctx.cubeOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["data-testid", "onClick"]))
                            : (_openBlock(), _createBlock(_component_ion_chip, {
                                key: 1,
                                outline: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.translate("on hand", { qoh: _ctx.productQoh[item.productId] })) + " ", 1),
                                  _createVNode(_component_ion_icon, {
                                    color: "medium",
                                    icon: _ctx.cubeOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1024))
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_ion_item, { lines: "none" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, { slot: "end" }, {
                                default: _withCtx(() => [
                                  (!item.orderItemSeqId)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.translate(' Received', { received: item.quantityAccepted ?? 0 })) + " ", 1),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.translate('Manually added')), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.translate(' Received | Fulfilled | Ordered',{ received: item.totalReceivedQuantity ?? 0, fulfilled:item.totalIssuedQuantity ?? 0 , ordered: item.quantity })), 1)
                                      ], 64))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ], 8, _hoisted_32)
                    ]),
                    _: 2
                  }, 1032, ["data-testid", "class", "id"]))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_ion_toast, {
            isOpen: _ctx.showToast,
            message: _ctx.translate('All items are ready for receiving'),
            position: "bottom",
            buttons: _ctx.toastButtons,
            "position-anchor": "footer"
          }, null, 8, ["isOpen", "message", "buttons"])
        ]),
        _: 1
      }),
      (!_ctx.isTOReceived() && _ctx.selectedSegment !== 'received')
        ? (_openBlock(), _createBlock(_component_ion_footer, {
            key: 0,
            "data-testid": "transfer-order-detail-page-footer",
            id: "footer",
            ref: "footer"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        "data-testid": "transfer-order-detail-page-save-progress-btn",
                        disabled: !_ctx.areAllItemsHaveQty || _ctx.receiveFlowBusy,
                        class: "ion-margin-end",
                        fill: "outline",
                        size: "small",
                        color: "primary",
                        onClick: _ctx.receiveTO
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.translate("Save Progress")) + _toDisplayString(":") + " " + _toDisplayString(_ctx.getReceivedUnits()), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode(_component_ion_button, {
                        "data-testid": "transfer-order-detail-page-receive-complete-btn",
                        disabled: !_ctx.areAllItemsHaveQty || _ctx.receiveFlowBusy,
                        fill: "solid",
                        size: "small",
                        color: "primary",
                        onClick: _ctx.receiveAndCloseTO
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.translate("Receive and complete")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}